export const SET_ACTIVE_UNIT = 'SELECT_UNIT';
export const SET_ALL_UNITS = 'SELECT_ALL_UNITS';
export const UPDATE_ACTIVE_UNIT = 'UPDATE_ACTIVE_UNIT';
export const SET_ME_PERMISSIONS = 'SET_ME_PERMISSIONS';
